<template>
  <v-bottom-navigation app light mandatory grow
                       min-width="auto"
                       :value="current"
                       :height="setHeight"
                       class="bottom-menu"
  >
    <v-btn plain icon depressed :ripple="false"
           v-for="(menu, n) in menus"
           :key="n"
           @click="menuClick(menu)">
      <span class="label">{{ menu.codeName }}</span>
      <component v-if="isSamsungFire"
                 :is="menu.icon"
                 :active="$route.path === menu.url || n === current" />
      <i v-else :class="[`cu-icon-bottom-menu-${menu.icon.toLowerCase()}`, { 'active' : n === current }]"></i>
      <span v-if="menu.code === 'Chat' && $store.state.common.notifications.realtalk === true" class="new-chat">N</span>
    </v-btn>
    <Modal :dialog="dialog" :str="modalText" @close="modalClose"/>
  </v-bottom-navigation>
</template>

<script>
import store from '@/store'
import {mixinAuth, mixinRemote, mixinSocket} from '@/mixins'
import Home from '@/components/icons/MenuHome'
import Library from '@/components/icons/MenuLibrary'
import Chat from '@/components/icons/MenuChat'
import Mission from '@/components/icons/MenuMission.vue'
import Square from '@/components/icons/MenuSquare'
import Travel from '@/components/icons/MenuTravel'
import Modal from '@/components/layout/modal/Modal'

export default {
  components: {
    Home,
    Library,
    Chat,
    Mission,
    Square,
    Travel,
    Modal
  },
  mixins: [ mixinAuth, mixinRemote, mixinSocket ],
  props: {
    current: Number,
  },
  data: () => ({
    dialog: false,
    modalText: '',
    travelApplStepCd: '0001',
    applResult: true,
    selectMenu: null,
    isMoveMenu: false,
    realTalkNew: false,
  }),
  computed: {
    menus () {
      // 개발시 미션 바텀 확인을 위해서 pub만 적용
      if (window.location.href.includes('/pub')) {
        return [
          { code: 'Home', codeName: '메인', url: '/', icon: 'Home' },
          { code: 'Library', codeName: '도서관', url: '/fo/library', icon: 'Library' },
          { code: 'Mission', codeName: '미션', url: '/pub/fo/mission', icon: 'Mission' },
          { code: 'Square', codeName: '광장', url: '/fo/square', icon: 'Square' },
          { code: 'Travel', codeName: '여행가방', url: '/fo/suitcase', icon: 'Travel' }
        ]
      }
      return [
        { code: 'Home', codeName: '메인', url: '/', icon: 'Home' },
        { code: 'Library', codeName: '도서관', url: '/fo/library', icon: 'Library' },
        { code: 'Mission', codeName: '미션', url: '/fo/mission', icon: 'Mission' },
        { code: 'Square', codeName: '광장', url: '/fo/square', icon: 'Square' },
        { code: 'Travel', codeName: '여행가방', url: '/fo/suitcase', icon: 'Travel' }
      ]
    },
    setHeight () {
      if (this.isSamsungFire) return '90px'
      return '100px'
    }
  },
  async created() {
    await this.goByTicket()

    // @DEPRECATED
    // if (store.state.client.contract.allowsRealtalkService && store.state.client.contract.realtalkMasterNo) {
    //   await this.findUnreadReatalkMessage();
    //   await store.dispatch('getHeaderRealtalk')
    // }
  },
  async mounted () {
    await store.dispatch('getUseOrdDtl')
  },
  methods: {
    // notificationSockConnect() {
    //   const url = '/v1/user/sub/queue';
    //   const subscribeCallback = (res) => {
    //     let body = JSON.parse(res.body)
    //     if (
    //         ((store.state.client.contract.realtalkMasterNo * 1 === body.realtalkMasterNo * 1) || body.feedbackYn === true)
    //           && this.$route.path !== "/fo/chatting"
    //     ) {
    //       store.commit("receiveRealtalk", true)
    //     }
    //   }
    //   const subscribeChannels = [
    //     { url: `/user${url}`, callback: subscribeCallback},
    //     { url: `${url}/dms-user-${store.state.auth.authUser.userKey}`, callback: subscribeCallback}
    //     // { url: `${url}/dms-user`, callback: subscribeCallback},
    //     // { url: `${url}/#{channel}`, callback: subscribeCallback}
    //   ]
    //   this.basicConnectSocket(null, subscribeChannels);
    // },
    // async findUnreadReatalkMessage() {
    //   if (!store.state.realtalk.init) {
    //     await store.dispatch('findUnreadReatalkMessage', this.$_payload('so', [{}]))
    //       .then(res => {
    //         if (res.success) {
    //           store.commit("initRealtalk", true)
    //           if (res.data) {
    //             store.commit("receiveRealtalk", true)
    //           }
    //           this.notificationSockConnect()
    //         }
    //       })
    //       .catch(error => {
    //         console.error(error)
    //       })
    //   }
    // },
    modalClose() {
      this.dialog = false;
    },
    active (menu) {
      return (this.current === menu) ? true : false;
    },
    cancel () {
      this.dialog = false;
    },
    goTravelPage (type) {
      // travelApplStepCd = 사전검사(0001), 중간검사(0002), 사후검사(0003)
      // startType = 단계별 처음(S), 단계별 다시시작(R)
      // 단계별 다시시작은 각 검사 단계의 결과까지 보았으나 다시 검사를 하는 경우 사용한다.
      this.$router.push({name: "travelIntro", query: {travelApplStepCd: this.travelApplStepCd, startType: type}});
    },
    /* 메뉴 클릭 */
    menuClick (menu) {
      this.isMoveMenu = true
      // 다른 메뉴 이동시 무조건 today's plan 닫음
      if (menu.code !== 'Home') {
        this.solutionComplete = false
      }
      if (this.applResult === false && this.isSamsungFire) {
        this.selectMenu = menu
        this.$alert('여행지원서를 먼저 완료하셔야</br>서비스 이용이 가능합니다.')
        // this.modalText = '여행지원서를 먼저 완료하셔야</br>서비스 이용이 가능합니다.'
        // this.dialog = true
        return false
      }

      if (menu.code === 'Chat') {
        if (!store.state.client.contract.allowsRealtalkService) {
          this.$alert('현재 이용 중인 티켓에는</br>찐한대화가 포함되어 있지 않아요.');
          return false
        }

        if (this.travelYn === 'N' && this.isFirst === true) {
          this.selectMenu = menu
          this.$alert('찐한 대화는</br>티켓 ' + (store.state.auth.authUser.memberGb === '02' ? '구매' : '사용') + ' 후 이용이 가능합니다.')
          return false
        }
        if(!this.isChat){
          menu.url = '/fo/chatting/lastDetail'
        }
      }
      this.isMoveMenu = false
      this.selectMenu = null
      this.movePage(menu.url)
    },
    async goByTicket() { // 여행지원서 완료여부 확인
      await store.dispatch('getMemberApplResultCnt', this.$_payload('so', [
        {'travelApplNo': 1},
        {'memberNo': this.userKey},
        {'travelApplStepCd': ''}
      ]))
          .then(res => {
            if (res.success) {
              if (res.data > 0) {
                // this.$alert("현재 완료한 여행지원서가 없습니다. 먼저 여행지원서를 작성해주세요.")
                //this.modalText = "현재 완료한 여행지원서가 없습니다. 먼저 여행지원서를 작성해주세요.";
                //this.dialog = true;
                this.applResult = true;
              } else {
                //this.$router.push({ name: "travelIntro", params: { travelApplStepCd: "0001", startType: 'S' } });
                //this.ticketStart()
                this.applResult = false;
              }
            } else {
              console.log(res.msg)
              this.applResult = false;
            }
          })
          .catch(error => {
            console.error(error)
            this.applResult = false;
          })
          .finally(() => {
          })
    },

    // async findRealtalk() {
    //   await store.dispatch('findRealtalk', this.$_payload('so', [{}]))
    //       .then(res => {
    //         if (res.data != null) {
    //
    //           if (res.data.message != null) {
    //             for (let i = res.data.message.length - 1; i > -1; i--) {
    //               let message = res.data.message[i];
    //
    //               // console.log(message.userReadYn);
    //               if(message.userType != 'dms-user' && message.userReadYn === false){
    //                 this.RealTalkNew = true;
    //               }
    //             }
    //           }
    //         }
    //       })
    //       .catch(error => {
    //         console.error(error)
    //       })
    //       .finally(() => {
    //       })
    //
    // },
  }
}
</script>
